(ns renolit-roofing-service.view.service.visit-program-view
  (:require [renolit-roofing-service.layout.components :as layout.components]
            [renolit-roofing-service.layout.icon :as layout.icon]
            [renolit-roofing-service.shared.util.map :refer [get-by-id]]
            [renolit-roofing-service.util.google-maps :as google-maps]
            [clojure.string :as str]
            [renolit-roofing-service.localization :refer [t]]))

(defn zone-pill
  [zone-name]
  [:span.zone-pill zone-name])

(defn task-block
  [task-type occurrences]
  [:div.task-card
   [:div.task-card__title
    (t [(keyword (str "domain.choices.task-type/" (name task-type)))])]
   (for [{:keys [subzone-name comment poi-id]} occurrences]
     ^{:key (str poi-id "-" subzone-name "-" comment)}
     [:div.task-card__body
      [:div.task-card__zones
       [zone-pill subzone-name]]
      (when (and comment (not (str/blank? comment)))
        [:div.task-card__comments
         [layout.icon/icon {:key :message :class "task-card__comments-icon"}]
         [:span.task-card__comments-text comment]])])])

(defn poi-type-section
  [review-type tasks-by-task-type]
  [:div.poi-type-section
   [:span
    (t [(keyword (str "domain.choices.revision-type/" (name review-type) "-revision"))])]
   (for [[task-type occurrences] (sort-by (fn [[k _]] (name k)) tasks-by-task-type)]
     ^{:key (str review-type "-" task-type)}
     [task-block task-type occurrences])])

(defn wp-type-section
  [wp-type review-types]
  [layout.components/collapsable-section
   {:title (t [(keyword (str "domain.choices.wp-type/" (name wp-type)))])
    :start-open true
    :class "collapsable-section--nested"}
   (for [review-type (sort (keys review-types))]
     (let [tasks-by-task-type (get review-types review-type)]
       (when (seq tasks-by-task-type)
         ^{:key (str wp-type "-" review-type)}
         [poi-type-section review-type tasks-by-task-type])))])

(defn wp-section
  [wp wp-types]
  [layout.components/collapsable-section
   {:title (t [(keyword (str "domain.choices.wp/" (name wp)))])
    :icon [google-maps/wp-icon wp]
    :start-open true}
   (for [[wp-type review-types] (sort-by (fn [[k _]] (name k)) wp-types)]
     ^{:key (str wp "-" wp-type)}
     [wp-type-section wp-type review-types])])

(defn- group-reviews-by-wp-type
  [{:keys [zones reviews]}]
  (let [tasks (->> reviews
                   (map (fn [{:keys [id type wp wp-type zone-id tasks]}]
                          (map (fn [{:keys [task-type comment]}]
                                 {:id id
                                  :type type
                                  :wp wp
                                  :wp-type wp-type
                                  :task-type task-type
                                  :zone-id zone-id
                                  :zone-name (:name (get-by-id zones zone-id))
                                  :comment comment})
                               tasks)))
                   (flatten))]
    (reduce (fn [acc {:keys [id type wp wp-type task-type
                             zone-id zone-name comment]}]
              (update-in acc [wp wp-type type task-type]
                         (fn [v]
                           (conj v {:id id
                                    :zone-id zone-id
                                    :subzone-name zone-name
                                    :comment comment}))))
            {}
            tasks)))

(defn work-packages-panel
  [service]
  (let [idx (group-reviews-by-wp-type service)]
    [:div
     (for [[wp wp-types] (sort-by (fn [[k _]] (name k)) idx)]
       ^{:key (str wp)}
       [wp-section wp wp-types])]))

(defn main
  [service]
  [:div.visit-program
   [work-packages-panel service]])
